




















































import { Component, Prop, Vue } from 'vue-property-decorator';
import Warning from '@/components/page/Warning.vue';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';

export class ProductPipelineSettingDTO {
  needCompile: boolean; // true代表需要编译部署
  isTest: boolean; // true代表测试环境，false代表正式环境
  includeAppKeys: Array<string>; // 流水线执行包含的应用Key集合，不能为空
  appList: Array<APP>; // 产品下所有的应用列表
  includeFront: boolean; // true代表编译前端网站

  constructor(needCompile = false, isTest = true, includeAppKeys: Array<string> = [], appList: Array<APP> = [], includeFront = false) {
    this.needCompile = needCompile;
    this.isTest = isTest;
    this.includeAppKeys = includeAppKeys;
    this.appList = appList;
    this.includeFront = includeFront;
  }
}

@Component({
  components: {
    Warning
  }
})
export default class ProductPipelineSetting extends Vue {
  @Prop() entity!: ProductPipelineSettingDTO; // 编辑的工作空间，为空则新建
  private settingDTO: ProductPipelineSettingDTO = null;
  private isTest: string;
  private isCompile: string;
  private checkAll = false;
  private isIndeterminate = false;
  private checkedAPPs: Array<string> = new Array<string>();
  private allAPPs: Array<string> = new Array<string>();
  private checkFront = false;

  constructor() {
    super();
    if (!this.entity) {
      this.settingDTO = new ProductPipelineSettingDTO();
    } else {
      this.settingDTO = this.entity;
    }
    this.isTest = this.settingDTO.isTest ? '测试环境' : '正式环境';
    this.isCompile = this.settingDTO.needCompile ? '阶段二：编译、镜像并部署' : '阶段一：生成代码并发布数据库';
    this.checkedAPPs.push(...this.settingDTO.includeAppKeys);
    this.settingDTO.appList.forEach(item => this.allAPPs.push(item.aPPKey));
  }

  cancel() {
    (this.$refs.settingDTO as any).resetFields();
    this.$emit('closeDialog', null);
  }

  confirm() {
    this.settingDTO.includeAppKeys = this.checkedAPPs;
    this.settingDTO.includeFront = this.checkFront;
    this.$emit('closeDialog', this.settingDTO);
  }

  setIsTest() {
    this.settingDTO.isTest = this.isTest === '测试环境';
  }

  setIsCompile() {
    this.settingDTO.needCompile = this.isCompile === '阶段二：编译、镜像并部署';
  }

  handleCheckAllChange(value: boolean) {
    this.checkedAPPs = value ? this.allAPPs : [];
    this.isIndeterminate = false;
  }

  handleCheckFrontChange(value: boolean) {
    this.checkFront = value;
  }

  handleCheckedAPPsChange(value: Array<string>) {
    const checkedCount = value.length;
    this.checkAll = checkedCount === this.checkedAPPs.length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < this.allAPPs.length;
  }

  get labelWidth() {
    return '10px';
  }
}

